module.exports = __webpack_public_path__ + "img/7cc73fd8-ef7a-4bad-a7b9-a6b83fc8b2be.dc422829.jpg";